module.exports = __webpack_public_path__ + "img/41.0cc4fb2e.jpg";